import React, { useState, useEffect} from "react";
import { NextSeo } from "next-seo";
import { Nav } from "@/components/navigation/Navbar";
import Crumbs from "@/components/navigation/Crumbs";
import * as Text from "@/components/text";
import Image from "next/image";
import qs from "qs";
import apiClient from "@/utils/apiClient";
import HeroMedia from "@/components/lib/HeroMedia";
import DownloadableMaterials from "@/components/initiatives/DownloadableMaterials";
import QA from "@/components/initiatives/QA";
import Testimonials from "pages/iniciativas/Testimonials";
import Editions from "@/components/vivero/Editions";
import { localeTexts } from "@/utils/locale";

export default function Vivero({mediaCenter, locale}) {
    const [mediaCenterData, setMediaCenterData] = React.useState({...mediaCenter});

    useEffect(() => {
      if (locale !== 'es-MX' && mediaCenter.localizations?.data?.length > 0) {
        const localizedData = mediaCenter.localizations.data.find(
          (localization) => localization.attributes.locale === locale
        );
  
        if (localizedData) {
          setMediaCenterData({
            ...mediaCenter,
            ...localizedData.attributes,
          });
        } else {
          setMediaCenterData({ ...mediaCenter });
        }
      } else {
        setMediaCenterData({ ...mediaCenter });
      }
    }, [locale, mediaCenter]);

  return (
    <>
      <div className="amb-container">
        <Nav className="bg-gray-100 grow" theme="light" />
        <NextSeo
          title="Vivero - Ambulante"
          description="Vivero"
          canonical={`https://ambulante.org/vivero}`}
          openGraph={{
            url: `https://ambulante.org/vivero`,
            title: "Vivero - Ambulante",
            description:
              "Vivero",
            site_name: "Ambulante",
          }}
        />
        <div className="flex flex-row gap-2 py-4">
          <Crumbs
            breadcrumbs={[
              { href: "/", text: localeTexts[locale].breadcrumbs.Home },
              {
                href: "/iniciativa/vivero",
                text: localeTexts[locale].breadcrumbs.programs,
              },
            ]}
          />
          <Text.NavigationLabel className="mt-0.5 text-xs font-thin text-neutral-600 md:mt-1.5">
            Vivero
          </Text.NavigationLabel>
        </div>
        <div className="flex flex-col items-center justify-center mb-8 text-center mt-7 md:mt-10 md:px-28 lg:mt-14 lg:px-32">
          <div className="w-full font-bold text-center text-vivero lg:mb-1">
            <Text.Title className="text-[22px] md:text-2xl md:font-semibold lg:text-2xl">
              Vivero
            </Text.Title>
          </div>
        <div className="w-full max-w-[750px] text-center text-xl font-normal leading-7 lg:mt-4 lg:text-[30px] lg:leading-[42px]">
            <h2 className="font-bold">{mediaCenterData?.title}</h2>
          </div>
          <div className={`w-full max-w-[950px] text-center text-sm font-light leading-7 lg:mt-4 lg:text-[18px] lg:leading-[22px] bg-[#d1ffd1] p-4 rounded-md`}>
            {mediaCenterData?.description}
          </div>
        </div>
              {mediaCenter?.hero_media && <div className="flex items-center justify-center w-full">
                  <div className="w-full pb-8 lg:max-w-[1440px] lg:pt-12">
                    <HeroMedia media={mediaCenter?.hero_media} />
                  </div>
                </div>}
               <hr className="border-black my-8" />
                  <div className="py-4 amb-ambulante md:mb-8">
                     <Text.Headline className="text-[40px]">MANIFIESTO</Text.Headline>
                  </div>
                    <div className="flex flex-col items-center gap-8 my-8 md:flex-row">
                        <div className="w-full md:w-1/2">
                        {mediaCenterData.media?.[0] ? (
                          <div className={`text-sm font-light leading-7 lg:text-[18px] lg:leading-[22px]`}>
                                <p>{mediaCenterData.media[0].description}</p>
                            </div>
                        ): null}
                        </div>
                        <div className="w-full md:w-1/2">
                            {mediaCenter.media?.[0]?.image?.data?.attributes?.url && (
                                <div className="relative h-[500px] w-full overflow-hidden">
                                    <Image
                                        src={mediaCenter.media[0].image.data.attributes.url}
                                        alt={mediaCenter.media[0].title || 'Media image'}
                                        layout="fill"
                                        objectFit="cover"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                      <div className="flex flex-col items-center gap-8 my-8 md:flex-row">
                          <div className="w-full md:w-1/2">
                              {mediaCenter.media2?.[0]?.image?.data?.attributes?.url && (
                                  <div className="relative h-[500px] w-full overflow-hidden">
                                      <Image
                                          src={mediaCenter.media2[0].image.data.attributes.url}
                                          alt={mediaCenter.media2[0].title || 'Media image'}
                                          layout="fill"
                                          objectFit="cover"
                                      />
                                  </div>
                              )}
                          </div>
                            <div className="w-full md:w-1/2">
                            {mediaCenterData.media2?.[0] ? (
                              <div className={`text-sm font-light leading-7 lg:text-[18px] lg:leading-[22px]`}>
                                    <p>{mediaCenterData.media2[0].description}</p>
                                </div>
                            ): null}
                            </div>
                    </div>
                      <div className="flex flex-col items-center gap-8 my-8 md:flex-row">
                        <div className="w-full md:w-1/2">
                        {mediaCenterData.media3?.[0] ? (
                          <div className={`text-sm font-light leading-7 lg:text-[18px] lg:leading-[22px]`}>
                                <p>{mediaCenterData.media3[0].description}</p>
                            </div>
                        ): null}
                        </div>
                        <div className="w-full md:w-1/2">
                            {mediaCenter.media3?.[0]?.image?.data?.attributes?.url && (
                                <div className="relative h-[500px] w-full overflow-hidden">
                                    <Image
                                        src={mediaCenter.media3[0].image.data.attributes.url}
                                        alt={mediaCenter.media3[0].title || 'Media image'}
                                        layout="fill"
                                        objectFit="cover"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                  <hr className="border-black my-8" />
            <div className="space-y-3">
              <DownloadableMaterials
                data={mediaCenterData?.downloads}
                label={localeTexts[locale].initiatives.vivero.convocatoria}
                locale={locale}
                showCategoryLabel={false}
              />
            <QA
              data={mediaCenterData?.qa}
              label={localeTexts[locale].common.faq}
            />
            </div>
            <Editions
              data={mediaCenterData?.edicion}
              locale={locale}
              title={localeTexts[locale].initiatives.vivero.editionsTitle}
              subtitle={localeTexts[locale].initiatives.vivero.editionsSubtitle}
            />
            <hr className="border-black my-8" />
            {/* <div className="flex justify-center py-8 mt-16">
              <Testimonials
                locale={locale}
                title={localeTexts[locale].initiatives.vivero.quotesTitle}
                subtitle={localeTexts[locale].initiatives.vivero.quotesSubtitle}
                quotes={mediaCenterData?.quotes}
              />
            </div> */}
      </div>
    </>
  );
}

export async function getServerSideProps(context) {
  const { locale } = context;
  const q = qs.stringify({
    populate: {
      qa: "*",
      quotes: "*",
      downloads: "*",
      hero_media: "*",
      edicion: {
        populate: {
            preview_image: "*",
            media: {
                populate: {
                    image: "*"
                }
            },
            media2: {
                populate: {
                    image: "*"
                }
            },
            download_urls: "*",
        }
      },
      media: {
        populate: "*",
      },
      media2: {
        populate: "*",
      },
      media3: {
        populate: "*",
      },
      localizations: {
        populate: {
            qa: "*",
            quotes: "*",
            downloads: "*",
            hero_media: "*",
            edicion: {
                populate: {
                    preview_image: "*",
                    media: {
                        populate: {
                            image: "*"
                        }
                    },
                    media2: {
                        populate: {
                            image: "*"
                        }
                    },
                    download_urls: "*",
                }
            },
            media: {
                populate: "*",
            },
            media2: {
                populate: "*",
            },
            media3: {
                populate: "*",
            },
        }
      }
    },
  });
  const { data } = await apiClient.get(`/api/vivero?${q}`);

  return {
    props: {
      mediaCenter: data.data.attributes,
      locale: locale || "es-MX",
    },
  };
}